/* ----------------------------------------------------------------------
   PP — Bundle Builder: Stock-Guard v2

   Verhindert, dass derselbe Design-Variant öfter gewählt werden kann
   als Shopify-Bestand vorhanden ist (inventoryPolicy DENY).

   Produktdaten werden direkt aus dem Card-DOM gelesen
   (script[data-bb-card-product]) — nicht aus cfg.products, das
   beim Drawer-Open noch leer sein kann.
   ---------------------------------------------------------------------- */
(function () {
  'use strict';

  /* ── Produktdaten aus Card-DOM ───────────────────────────────── */

  function getCardProduct(card) {
    var el = card.querySelector('script[data-bb-card-product]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function getVariantIdFromCard(card) {
    var sel = card.querySelector('[data-bundle-variant-select]');
    return String(sel ? sel.value : card.getAttribute('data-default-variant-id') || '');
  }

  function getVariantData(card) {
    var product = getCardProduct(card);
    if (!product || !Array.isArray(product.variants)) return null;
    var vid = getVariantIdFromCard(card);
    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === vid) return product.variants[i];
    }
    return product.variants[0] || null;
  }

  function isStockLimited(variant) {
    if (!variant) return false;
    /* Kein Tracking = unbegrenzt */
    var mgmt = String(variant.inventory_management || '').toLowerCase();
    if (!mgmt || mgmt === 'null' || mgmt === '') return false;
    /* CONTINUE = darf überverkauft werden */
    var policy = String(variant.inventory_policy || '').toLowerCase();
    if (policy === 'continue') return false;
    return true;
  }

  function getAvailableQty(variant) {
    var q = parseInt(variant.inventory_quantity, 10);
    return isFinite(q) ? Math.max(0, q) : 0;
  }

  /* ── Drawer-Zähler aus qty-Inputs rekonstruieren ──────────────── */

  function getDrawerCounts(drawer) {
    var counts = {};
    drawer.querySelectorAll('[data-bundle-drawer-card]').forEach(function (card) {
      var vid = getVariantIdFromCard(card);
      if (!vid) return;
      var input = card.querySelector('[data-qty-input]');
      var n = input ? parseInt(input.value, 10) : 0;
      if (!isFinite(n) || n <= 0) return;
      counts[vid] = (counts[vid] || 0) + n;
    });
    return counts;
  }

  /* ── Plus-Buttons syncen ──────────────────────────────────────── */

  function syncPlusButtons(drawer) {
    if (!drawer) return;
    var counts = getDrawerCounts(drawer);

    drawer.querySelectorAll('[data-bundle-drawer-card]').forEach(function (card) {
      var plus = card.querySelector('[data-qty-plus]');
      if (!plus) return;

      var variant = getVariantData(card);
      if (!variant || !isStockLimited(variant)) {
        /* Unbegrenzt: sicherstellen dass Button aktiv ist */
        plus.disabled = false;
        plus.style.opacity = '';
        plus.style.cursor = '';
        plus.removeAttribute('aria-disabled');
        return;
      }

      var available = getAvailableQty(variant);
      var vid = getVariantIdFromCard(card);
      var current = counts[vid] || 0;
      var atLimit = current >= available;

      plus.disabled = atLimit;
      plus.style.opacity = atLimit ? '0.35' : '';
      plus.style.cursor = atLimit ? 'not-allowed' : '';
      plus.setAttribute('aria-disabled', atLimit ? 'true' : 'false');
    });
  }

  /* ── Event: Klick auf + blockieren wenn Limit erreicht ──────────── */

  function handlePlusClick(e) {
    var plus = e.target.closest('[data-qty-plus]');
    if (!plus) return;

    var drawer = plus.closest('x-drawer.bk-media-bundle-builder__drawer');
    if (!drawer) return;

    var card = plus.closest('[data-bundle-drawer-card]');
    if (!card) return;

    var variant = getVariantData(card);
    if (!variant || !isStockLimited(variant)) return;

    var available = getAvailableQty(variant);
    var counts = getDrawerCounts(drawer);
    var vid = getVariantIdFromCard(card);
    var current = counts[vid] || 0;

    if (current >= available) {
      e.preventDefault();
      e.stopImmediatePropagation();
      syncPlusButtons(drawer);
      return;
    }

    /* Nach dem nativen Handler neu syncen */
    requestAnimationFrame(function () { syncPlusButtons(drawer); });
  }

  /* ── Drawer geöffnet: initial + nach Feed-Load syncen ──────────── */

  var syncTimers = {};

  function scheduleSyncForDrawer(drawer, delayMs) {
    var id = drawer.id || 'default';
    clearTimeout(syncTimers[id]);
    syncTimers[id] = setTimeout(function () {
      syncPlusButtons(drawer);
    }, delayMs || 0);
  }

  function onDrawerShow(e) {
    var drawer = e.target;
    if (!drawer || !drawer.classList.contains('bk-media-bundle-builder__drawer')) return;
    /* Mehrfach pollen bis Feed-Cards geladen */
    var attempts = 0;
    var iv = setInterval(function () {
      syncPlusButtons(drawer);
      if (++attempts >= 12) clearInterval(iv);
    }, 200);
  }

  /* Nach Tab-Wechsel und Feed-Nachladen neu syncen */
  function onDrawerClick(e) {
    var tab = e.target.closest('.bk-media-bundle-drawer__filter--collection-tab');
    if (tab) {
      var drawer = tab.closest('x-drawer.bk-media-bundle-builder__drawer');
      if (drawer) {
        var attempts = 0;
        var iv = setInterval(function () {
          syncPlusButtons(drawer);
          if (++attempts >= 12) clearInterval(iv);
        }, 200);
      }
    }
  }

  /* MutationObserver: neue Cards die per InfiniteScroll reinkommen */
  function observeDrawerCards() {
    var drawers = document.querySelectorAll('x-drawer.bk-media-bundle-builder__drawer');
    drawers.forEach(function (drawer) {
      if (drawer._ppStockGuardObserver) return;
      var obs = new MutationObserver(function () {
        scheduleSyncForDrawer(drawer, 80);
      });
      obs.observe(drawer, { childList: true, subtree: true });
      drawer._ppStockGuardObserver = obs;
    });
  }

  /* ── Binding ──────────────────────────────────────────────────── */

  function bind() {
    document.addEventListener('click', handlePlusClick, true);
    document.addEventListener('dialog:after-show', onDrawerShow, false);
    document.addEventListener('click', onDrawerClick, false);
    observeDrawerCards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', function () {
    observeDrawerCards();
  });

})();
